// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecommerce-divhead {
  min-height: 80px;
}

.line-div-max-length-ecommerce {
  width: 100%;
  border-bottom: 0.5px solid #28af4b;
  position: absolute;
  bottom: 7px;
  max-width: 130px;
}
.card-ecommerce {
  padding: 2px !important;
}

/* ---------------------------------------------------------------------------------------------- */

.carousel-heading {
  font-family: "Poppins", sans-serif;
  font-size: 38px;
  font-weight: 700;
}

.carousel-inner-text {
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #333132;
}

@media (max-width: 600px) {
  .carousel-heading {
    font-size: 14px;
  }
  .carousel-inner-text {
    font-size: 10px;
  }
}

.homepage-carousel .carousel-indicators {
  position: absolute;
  bottom: -5%;
  left: 66% !important;
  right: 0;
  margin-left: auto;
  margin-right: 0;
  width: 33%;
  display: flex;
  justify-content: center;
  /* background-color: red; */
}

.homepage-carousel .carousel-indicators li {
  background-color: #707070;
  border: 1px solid #ffffff; /* Adjust border color */
  border-radius: 50%; /* Make it round */
  width: 10px; /* Adjust size */
  height: 10px; /* Adjust size */
  margin: 0 2px; /* Adjust spacing */
  cursor: pointer;
  transition: background-color 0.3s ease;
  list-style: none; /* Hide the numbers */
}

.homepage-carousel .carousel-indicators li.active {
  background-color: #09ed0d; /* Active indicator color */
  width: 15px;
  border-radius: 45%;
}

.image-in-carousel {
  display: flex;
  align-items: center;
}

/* ----------------------------------------------------------------------------------------------- */
`, "",{"version":3,"sources":["webpack://./src/pages/css/ecommerce.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;;AAEA,mGAAmG;;AAEnG;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB,EAAE,wBAAwB;EACnD,kBAAkB,EAAE,kBAAkB;EACtC,WAAW,EAAE,gBAAgB;EAC7B,YAAY,EAAE,gBAAgB;EAC9B,aAAa,EAAE,mBAAmB;EAClC,eAAe;EACf,sCAAsC;EACtC,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oGAAoG","sourcesContent":[".ecommerce-divhead {\n  min-height: 80px;\n}\n\n.line-div-max-length-ecommerce {\n  width: 100%;\n  border-bottom: 0.5px solid #28af4b;\n  position: absolute;\n  bottom: 7px;\n  max-width: 130px;\n}\n.card-ecommerce {\n  padding: 2px !important;\n}\n\n/* ---------------------------------------------------------------------------------------------- */\n\n.carousel-heading {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 38px;\n  font-weight: 700;\n}\n\n.carousel-inner-text {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 700;\n  font-size: 20px;\n  color: #333132;\n}\n\n@media (max-width: 600px) {\n  .carousel-heading {\n    font-size: 14px;\n  }\n  .carousel-inner-text {\n    font-size: 10px;\n  }\n}\n\n.homepage-carousel .carousel-indicators {\n  position: absolute;\n  bottom: -5%;\n  left: 66% !important;\n  right: 0;\n  margin-left: auto;\n  margin-right: 0;\n  width: 33%;\n  display: flex;\n  justify-content: center;\n  /* background-color: red; */\n}\n\n.homepage-carousel .carousel-indicators li {\n  background-color: #707070;\n  border: 1px solid #ffffff; /* Adjust border color */\n  border-radius: 50%; /* Make it round */\n  width: 10px; /* Adjust size */\n  height: 10px; /* Adjust size */\n  margin: 0 2px; /* Adjust spacing */\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  list-style: none; /* Hide the numbers */\n}\n\n.homepage-carousel .carousel-indicators li.active {\n  background-color: #09ed0d; /* Active indicator color */\n  width: 15px;\n  border-radius: 45%;\n}\n\n.image-in-carousel {\n  display: flex;\n  align-items: center;\n}\n\n/* ----------------------------------------------------------------------------------------------- */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
